/*global _ */


export const props = {
  config: {
    type: [Boolean, Function, Object],
    default: () => ({})
  },
  type: {
    type: String,
    default: 'info'
  },
  id: {
    type: [String, Function],
  },
  message: {
    type: [String, Function],
  },
  title: {
    type: [String, Function],
  },
  containerClass: {
    type: [String, Array, Object],
    default: ''
  },
  buttonTitle: {
    type: String,
    default: 'Ok'
  },
  buttonClasses: {
    type: [String, Array, Object],
  },
  noClose: {
    type: [Boolean, Function],
    default: false
  }
}
export default {
  props,
  computed: {
    options() {
      return _.defaultsDeep({}, this.config || {}, _.pick(this, _.keys(_.omit(props, ['config']))))
    }
  },
  methods: {
    getModalClasses() {
      return [
        `re-modal-${this.options.type}`,
        ...this.getModalExtraClasses()
      ]
    },
    getModalExtraClasses() {
      return []
    },
    buttonClick() {
      this.respond(true);
    },
    respond(state) {
      this.close(state)
    },
    close(state = false) {
      const {then} = this.options
      then && then(state)
      this.$emit('close', state)
    }
  }
}
